import { OnlineIcon } from '@shared/assets';

import * as st from './styles.module.scss';

export const ButtonConnect = (): JSX.Element => {
    return (
        <button className={st.connect}>
            < OnlineIcon />
            <span>Подключиться</span>
        </button>
    )
}